export default __webpack_public_path__ + "static/media/checkbox_toggle_white.9bec120a.svg";